import { ImagePlus, Loader2, Search, ShoppingBag, X } from "lucide-react";
import { useMemo, useRef, useState } from "react";

import { Input } from "@/components/ui/input";
import { miniaturaDe } from "@/utils/miniatura";

import { urlImagem } from "../api";
import Cartao from "./Cartao";

function Produto({ p, escolhido, onEscolher }) {
  return (
    <button type="button" onClick={() => onEscolher(p)} data-e2e="impulsionar-produto" data-escolhido={escolhido ? "1" : "0"}
      className={`text-left rounded-xl border p-2 transition hover:border-primary ${escolhido ? "border-primary ring-2 ring-primary/30 bg-primary/5" : "bg-background"}`}>
      <img src={miniaturaDe(p.foto, 256)} alt="" loading="lazy" className="w-full aspect-square rounded-lg object-cover bg-muted" />
      <p className="text-xs font-medium mt-1.5 leading-tight line-clamp-2">{p.nome}</p>
      {p.vendidos > 0 && <p className="text-[10px] text-muted-foreground tabular-nums">{Math.round(p.vendidos)} vendidos em 30 dias</p>}
    </button>
  );
}

/** Passo 1: um produto do cardápio (a foto vem junto) ou uma imagem da loja. */
export default function SecaoOQueAnunciar({ a }) {
  const [busca, setBusca] = useState("");
  const arquivoRef = useRef(null);
  const produtos = a.dados.produtos;
  const visiveis = useMemo(() => {
    const termo = busca.trim().toLowerCase();
    return termo ? (produtos || []).filter((p) => p.nome.toLowerCase().includes(termo)) : (produtos || []);
  }, [produtos, busca]);
  const propria = a.form.propria;

  return (
    <Cartao numero={1} titulo="O que anunciar" icone={ShoppingBag} e2e="impulsionar-o-que"
      descricao="Escolha um produto do cardápio — a foto dele vai no anúncio. Os mais vendidos vêm primeiro.">
      {!produtos?.length ? (
        <p className="text-sm text-muted-foreground rounded-lg bg-muted px-3 py-3">
          Nenhum produto do cardápio tem foto ainda. Envie uma imagem sua aqui embaixo, ou cadastre a foto do produto em Cardápio.
        </p>
      ) : (
        <>
          <div className="relative mb-3">
            <Search className="w-4 h-4 text-muted-foreground absolute left-3 top-1/2 -translate-y-1/2" />
            <Input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar produto" className="pl-9" data-e2e="impulsionar-busca" />
          </div>
          <div className="grid grid-cols-3 sm:grid-cols-4 xl:grid-cols-6 gap-2 max-h-[21rem] overflow-y-auto pr-1">
            {visiveis.map((p) => <Produto key={p.id} p={p} escolhido={!propria && a.form.produtoId === p.id} onEscolher={a.escolherProduto} />)}
            {visiveis.length === 0 && <p className="col-span-full text-sm text-muted-foreground py-6 text-center">Nenhum produto com esse nome.</p>}
          </div>
        </>
      )}

      <div className="mt-4 pt-4 border-t flex flex-wrap items-center gap-3">
        <input ref={arquivoRef} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-e2e="impulsionar-arquivo"
          onChange={(e) => { a.enviarImagem(e.target.files?.[0]); e.target.value = ""; }} />
        {propria ? (
          <div className="flex items-center gap-3 min-w-0" data-e2e="impulsionar-propria">
            <img src={urlImagem(propria.imagem)} alt="" className="w-14 h-14 rounded-lg object-cover border bg-muted" />
            <div className="min-w-0 text-sm">
              <p className="font-medium">Usando a sua imagem</p>
              <p className="text-xs text-muted-foreground tabular-nums">{propria.largura} × {propria.altura}</p>
            </div>
            <button type="button" onClick={a.removerPropria} title="Voltar a usar a foto do produto"
              className="h-8 w-8 rounded-lg border flex items-center justify-center hover:bg-muted"><X className="w-4 h-4" /></button>
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">Prefere outra imagem? Envie a sua arte (JPG, PNG ou WebP; o ideal é 1080 × 1080).</p>
        )}
        <button type="button" onClick={() => arquivoRef.current?.click()} disabled={a.enviandoImagem} data-e2e="impulsionar-enviar-imagem"
          className="ml-auto inline-flex items-center gap-1.5 rounded-lg border px-3 py-2 text-sm font-medium hover:border-primary disabled:opacity-50">
          {a.enviandoImagem ? <Loader2 className="w-4 h-4 animate-spin" /> : <ImagePlus className="w-4 h-4" />}
          {propria ? "Trocar imagem" : "Enviar imagem"}
        </button>
      </div>
      {propria?.aviso && <p className="mt-2 text-xs text-amber-600">{propria.aviso}</p>}
    </Cartao>
  );
}
